import React, { FC, useEffect, useState } from 'react';

import '../Changelog.css';

import { Rollout } from '@/lib/App';

import './ChangelogItem.css';

import { Flex } from '@duxton-web/ui';

import { ChangelogWrapper } from './ChangelogWrapper';
import TimestampHeader from './TimestampHeader';
import { ModifiedRolloutTargetMapValue } from '@/common/dto/changelog';
import { getModifiedRolloutTargetsMap } from '@/utils/changelog';

interface OwnProps {
  'data-testid'?: string;
  changelog: any;
  renderDate?: boolean;
  latestRollout?: Rollout;
  onRestore?: (rollout: Rollout) => void;
  includeUnchanged?: boolean;
}

function DateTimeWrapper({ renderDate, changelog }) {
  if (!renderDate) return <></>;

  return <TimestampHeader changelog={changelog} />;
}

const ChangelogItem: FC<OwnProps> = ({
  'data-testid': dataTestId,
  changelog,
  renderDate = true,
  latestRollout = null,
  onRestore = () => {},
  includeUnchanged = false,
}) => {
  const [modifiedRolloutTargets, updateModifiedRolloutTargets] = useState(
    new Map<string, ModifiedRolloutTargetMapValue>(),
  );

  useEffect(() => {
    const modifiedRolloutTargetsMap = getModifiedRolloutTargetsMap(
      changelog?.rollout?.newRollout,
      changelog?.rollout?.oldRollout,
      includeUnchanged,
    );

    updateModifiedRolloutTargets(modifiedRolloutTargetsMap);
  }, [changelog, includeUnchanged]);

  return (
    <Flex vertical gap={8} className="changelog-item" data-testid={dataTestId}>
      <DateTimeWrapper renderDate={renderDate} changelog={changelog} />
      <ChangelogWrapper
        changelog={changelog}
        latestRollout={latestRollout}
        modifiedRolloutTargets={modifiedRolloutTargets}
        onRestore={onRestore}
      />
    </Flex>
  );
};

export default ChangelogItem;
